import styled from '@emotion/styled';
import {
  Card,
  Section,
  TextCaption,
  TextHighlight,
  TitleAndDescription,
  token,
} from '@ferreri/prever-component-lib';

export const HolderRule = ({ planVersion }) => {
  const { holder_rule } = planVersion ?? {};

  if (!holder_rule) return null;

  const { marital_status, min_age, max_age } = holder_rule;

  const items = [
    {
      label: 'Estado civil',
      value: marital_status,
    },
    {
      label: 'Idade mínima',
      value: min_age,
    },
    {
      label: 'Idade máxima',
      value: max_age,
    },
  ].filter((item) => item.value !== null && item.value !== undefined);

  if (items?.length === 0) return null;

  return (
    <Section>
      <TitleAndDescription title="Condições para titular" />
      <Container>
        {items?.map((item) => {
          const isAgeField = item.label?.toLowerCase().includes('idade');
          const displayValue = isAgeField ? `${item.value} anos` : item.value;

          return (
            <Card key={item?.label}>
              <Content>
                <TextHighlight>{displayValue}</TextHighlight>
                <TextCaption>{item?.label}</TextCaption>
              </Content>
            </Card>
          );
        })}
      </Container>
    </Section>
  );
};

const Container = styled.div`
  display: flex;
  gap: ${token.spacing.spacingXxSmall};
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: ${token.spacing.spacingXxxSmall};
`;
